import Link from '../Link';
import styles from './Next.module.scss';
import { Link as LinkI } from '../../models/common';

export type Props = {
  title?: string;
  link?: LinkI;
};

const Next = (props: Props): JSX.Element => {
  const { title, link } = props;
  return (
    <div className={styles.next}>
      {title && <div className="h4_italic">{title}</div>}
      <div className={styles.secondLine}>
        {link?.url && (
          <Link
            href={link?.url}
            type={link.style?.type}
            iconSize={link.style?.iconSize}
            textSize={link.style?.textSize}
            isIconFirst={link.style?.isIconFirst}
          >
            <h2>{link?.label}</h2>
          </Link>
        )}
      </div>
    </div>
  );
};
export default Next;
